import {
  COMPARE_PAGE_SCROLLING,
} from './actionTypes';

export default function reducer(state = 0, action) {
  switch (action.type) {
    case COMPARE_PAGE_SCROLLING:
      return action.margin;
    default: return state;
  }
}

// actions
export function updateScrollingMargin(margin) {
  return {
    type: COMPARE_PAGE_SCROLLING,
    margin,
  };
}
